import getUserRelapseAccess from '../Dashboard/utils/getUserRelapseAccess';

export const getModulePath = (user = {}) => {
  const { id, progress } = user;
  let path = '/module/:id';
  if (!id || !progress) return path;
  const relapseAccess = getUserRelapseAccess(user);
  if (+progress.module === 0) {
    path += '(0)';
  }
  if (+progress.module > 0) {
    path += '(';
    for (let i = 1; i <= progress.module; i++) path += `${i}|`;
    path += relapseAccess ? 'relapsemodule)' : ')';
  }
  return path;
};

export const getDailyAccess = (user = {}) => {
  const { id, progress, role } = user;
  if (!id) return true;
  if (role === 'support') return false;
  return !progress.daily_check;
};

export const getWeeklyAccess = (user = {}) => {
  const { id, progress, role } = user;
  if (!id) return true;
  if (role === 'support') return false;
  return !progress.relapse_risk;
};

export const getMonthlyAccess = (user = {}) => {
  const { id, progress, role } = user;
  if (!id) return true;
  if (role === 'support') return false;
  return !progress.satisfaction;
};

export const getSkillsAccess = (user = {}) => {
  const { id, progress, role } = user;
  if (role === 'support') return false;
  return id ? progress.module > 1 : false;
};

export const getSubscriptionAccess = (user = {}) => {
  const { id, progress, client_person, role } = user;
  if (!id) return true;

  return role === 'client'
    ? progress.subscription
    : client_person.progress.subscription;
};



// WEBPACK FOOTER //
// ./src/containers/Routes/utils.js